export default "__VITE_ASSET__da20630c__"